/** Tokens visuais — excluir evento (mesmo layout, ênfase em ação destrutiva) */
export const DELETE_EVENTO_ACCENT = "#d32f2f";
export const DELETE_EVENTO_INK = "#1a2035";
export const DELETE_EVENTO_ACCENT_SOFT = "rgba(211, 47, 47, 0.08)";

export const deleteEventoToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${DELETE_EVENTO_ACCENT}`,
};

export const deleteEventoSectionSx = {
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: "grey.200",
  bgcolor: "background.paper",
};

export const deleteEventoDangerSectionSx = {
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: "rgba(211, 47, 47, 0.35)",
  bgcolor: DELETE_EVENTO_ACCENT_SOFT,
};
